import './CompetitionsPage.css';
import Header from '../Header/Header.js';
import Footer from '../Footer/Footer.js';

const competitionFiles = ['Комплексный план мероприятий на 2026 год.pdf'];

function CompetitionsPage() {
  return (
    <>
      <Header />
      <main className="content">
        <section className="competitionsPage">
          <div className="competitionsPage__hero">
            <h2 className="competitionsPage__title">Конкурсы</h2>
            <p className="competitionsPage__lead">
              В разделе размещены актуальные документы и материалы по
              конкурсным мероприятиям Самарского областного отделения ВДПО
            </p>
          </div>

          <div className="competitionsPage__list">
            {competitionFiles.map((fileName, index) => (
              <article className="competitionsPage__card" key={fileName}>
                <div className="competitionsPage__card-content">
                  <p className="competitionsPage__card-number">
                    Документ {index + 1}
                  </p>
                  <h3 className="competitionsPage__card-title">
                    {fileName.replace('.pdf', '')}
                  </h3>
                </div>
                <a
                  href={`/images/vdpo_competitions/${encodeURIComponent(fileName)}`}
                  className="competitionsPage__card-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Открыть файл
                </a>
              </article>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default CompetitionsPage;
